/**
 * React Query Provider
 * Provides global React Query client for data fetching and caching
 */

import { QueryClientProvider } from '@tanstack/react-query';
import { getQueryClient } from 'config/queryClient';

// Get the singleton query client
const queryClient = getQueryClient();

/**
 * QueryProvider Component
 * Wraps the application with React Query's QueryClientProvider
 */
export function QueryProvider({ children }) {
  return (
    <QueryClientProvider client={queryClient}>
      {children}
    </QueryClientProvider>
  );
}

export default QueryProvider;
